module.exports = __webpack_public_path__ + "img/walmart-logo.ffb2bae2.png";